var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"v-resume-paginator"},_vm._l((_vm.list),function(option){return _c('li',{key:`paginator_option_${option.id}`,staticClass:"v-resume-paginator__item",class:{
			'active': _vm.activeTab == option.id,
			'is_mobile': option.isMobile
		},on:{"click":function($event){return _vm.updateTab(option.id)}}},[_vm._v("\n\t\t"+_vm._s(option.title)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }